export const LOOTBOX_INSUFFICIENT_ALLOWANCE_ERROR = 'insufficient allowance';
export const LOOTBOX_PRICE_INCREASED_ERROR = 'PriceInQTIncreased';
export const LOOTBOX_INSUFFICIENT_ALLOWANCE_ERROR_MESSAGE =
  'Price has been increased while processing. Please try again';
   